import React from 'react';
import Dialog, { DialogActionBar } from 'src/components/common/Dialog.redesign';
import Button from 'src/components/controls/forms/redesign/FormButton';

interface IConfirmActionDialogProps {
    onCloseDialog?: () => void;
    title: string;
    body: string | React.ReactElement;
    onConfirm: () => void;
    onCancel?: () => void;
}

const ConfirmActionDialog: React.FC<IConfirmActionDialogProps> = (props) => {
    const confirmAction = () => {
        props.onConfirm();
        props.onCloseDialog();
    };

    return (
        <Dialog title={props.title}>
            <div>{props.body}</div>
            <DialogActionBar>
                <Button intent="primary" onClick={confirmAction} text="Accept" />
                <Button intent="danger" onClick={props.onCloseDialog} text="Cancel" />
            </DialogActionBar>
        </Dialog>
    );
};

export default ConfirmActionDialog;



// WEBPACK FOOTER //
// ./src/components/common/dialogs/ConfirmActionDialog.tsx